import React, { Component } from 'react';
import { 
  Modal, 
  Button, 
  Form, 
  FormGroup, 
  FormControl, 
  Row, 
  Col, 
  ControlLabel,
  Alert 
} from 'react-bootstrap';

class NewPortfolioModal extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      accountHolder: '',
      accountNumber: '',
      error: ''
    };
  }

  renderAlert = () => {
    if (this.state.error) {
      return (
        <Alert bsStyle="danger">
          <strong>Oops!</strong> {this.state.error}
        </Alert>
      );
    }
  }

  onNewPortfolio = () => {
    const { name, accountHolder, accountNumber } = this.state;
    if (!name || !accountHolder || !accountNumber) {
      this.setState({ error: 'Please fill out all fields.'});
    } else {
      this.props.createNewPortfolio({
        name: name,
        accountHolder: accountHolder,
        accountNumber: accountNumber
      });
      this.closeModal();
    }
  }

  closeModal = () => {
    this.setState({ name: '', accountHolder: '', accountNumber: '', error: '' });
    this.props.closeModal('showNewPortfolioModal');
  }

  render() {
    return (
      <Modal show={this.props.showNewPortfolioModal} onHide={() => this.closeModal()} className="new-portfolio-modal">
        <Modal.Header closeButton>
          <Modal.Title>Create New Portfolio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Row>
            <Col mdOffset={2} md={8}>
              <Form onSubmit={(e) => e.preventDefault()}>
                <FormGroup controlId="name">
                  <ControlLabel>Portfolio Name:</ControlLabel>
                  <FormControl 
                    type="text" 
                    placeholder="" 
                    value={this.state.name} 
                    name="name" 
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
                </FormGroup>
                <FormGroup controlId="accountHolder">
                  <ControlLabel>Account Holder:</ControlLabel>
                  <FormControl 
                    type="text"
                    value={this.state.accountHolder}
                    name="accountHolder"
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
                </FormGroup>
                <FormGroup controlId="accountNumber">
                  <ControlLabel>Account Number:</ControlLabel>
                  <FormControl 
                    type="text"
                    value={this.state.accountNumber}
                    name="accountNumber"
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
                </FormGroup>
                {this.renderAlert()}
                <Button 
                  className="new-portfolio-btn btn-blue" 
                  bsStyle="primary"
                  onClick={() => this.onNewPortfolio()}
                >Create</Button>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            bsStyle="default"  
            onClick={() => this.closeModal()}
          >Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default NewPortfolioModal;